var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChartComparison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "18 18 25 22",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 21.0827V38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 38H34.4375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2812 23.1127H37.7187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23.5188C31.4423 23.5188 32.2062 22.7311 32.2062 21.7594C32.2062 20.7877 31.4423 20 30.5 20C29.5576 20 28.7937 20.7877 28.7937 21.7594C28.7937 22.7311 29.5576 23.5188 30.5 23.5188Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2814 23.1127L20 31.2782"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2812 23.1127L26.5625 31.2782"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.2331C22.1875 33.9398 24.375 33.9398 26.5625 31.2331"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7187 23.1127L34.4375 31.2782"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7188 23.1127L41 31.2782"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 31.2331C36.625 33.9398 38.8125 33.9398 41 31.2331"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.2782H26.125"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 30.8271H41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChartComparison);
export default __webpack_public_path__ + "static/media/ico_chart_comparison.1522c74185015a62a8862b48b576f556.svg";
export { ForwardRef as ReactComponent };